import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class customersMultiSelectListCtrl implements IController {
  selectedIds: any;
  optionIds: any;
  accountIds: string[];
  excludeIds: any;
  onChange: Function;

  private customersRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private $log, private $customers, private $infiniteScroll, private commonsService: CommonsService) {
  }

  $onInit() {
    this.customersRef = this.$customers();
    this.loadLimit = 20;

    this.customersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.customersRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onToggle(id, isSelected) {
    this.onChange({
      ids: isSelected ? _.concat(this.selectedIds || [], [id]) :
        _.filter(this.selectedIds, (selectedId) => {
          return selectedId !== id;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.optionIds) {
      this._reload();
    } else {
      this._search();
    }
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({ids: []});
    } else {
      this.onChange({ids: this.infiniteScroll?.getItems()?.map((customer) => customer.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.infiniteScroll?.getItems().map(customer => customer.id), this.selectedIds);
    return this.isSelectAll;
  }

  private _reload() {
    this.customersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _search() {
    this.infiniteScroll.search(this.queryString);
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      accountIds: this.accountIds,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.customers')
  .component('customersMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      accountIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./customers-multi-select-list.html').default,
    controller: customersMultiSelectListCtrl
  });
